import { Product } from '@framework/types'
import http from '@framework/utils/http'
import { API_ENDPOINTS } from '@framework/utils/api-endpoints'
import { useQuery } from '@tanstack/react-query'

export type RelatedProductsParams = {
  gpc_brick: string
  excludeId: number
  limit?: number
}

export const fetchRelatedProducts = async (params: RelatedProductsParams) => {
  try {
    const { data } = await http.get(API_ENDPOINTS.PRODUCTS, {
      params: {
        ...params,
        has_discount: 'true',
        limit: params.limit || 8
      }
    })

    return data.data
  } catch (error) {
    console.error('Error fetching related products:', error)
    return []
  }
}

export const fetchStoreDiscounts = async (storeId: number, excludeId: number) => {
  try {
    const { data } = await http.get(API_ENDPOINTS.PRODUCTS, {
      params: {
        store_id: storeId,
        has_discount: 'true',
        excludeId,
        limit: 8
      }
    })

    return data.data
  } catch (error) {
    console.error('Error fetching store discounts:', error)
    return []
  }
}

export const useRelatedProductsQuery = (product: Product) => {
  const params: RelatedProductsParams = {
    gpc_brick: product.gpc_brick,
    excludeId: product.id,
    limit: 8
  }

  return useQuery({
    queryKey: ['related-products', params],
    queryFn: () => fetchRelatedProducts(params),
    enabled: !!product.id && !!product.gpc_brick
  })
}

export const useStoreDiscountsQuery = (product: Product) => {
  return useQuery({
    queryKey: ['store-discounts', product.store_id],
    queryFn: () => fetchStoreDiscounts(product.store_id, product.id),
    enabled: !!product.id && !!product.store_id
  })
}
